export default __webpack_public_path__ + "static/media/result.126b12fc.svg";